import Prefix from "../config/ApiPrefix";

export default class Api {
  static host = process.env.REACT_APP_API_PATH+Prefix.api1;
  static url_patt = /^https?:\/\//i;
  static token = null;

  static setToken(token) {
    this.token = token;
  }

  static async get(route, params={}) {
    // Convert params for get request
    return Api.request(`${route}?${(new URLSearchParams(params)).toString()}`, null, 'GET');
  }

  static async put(route, data) {
    return Api.request(route, data, 'PUT');
  }

  static async patch(route, data) {
    return Api.request(route, data, 'PATCH');
  }

  static async post(route, data) {
    return Api.request(route, data, 'POST');
  }

  static async delete(route, data) {
    return Api.request(route, data, 'DELETE');
  }

  static async request(route, data, verb) {
    // Check if url is relative
    let url = route;
    if (!Api.url_patt.test(route)) {
      url = `${Api.host}${route}`;
    }

    // Prepaer options data
    let options = {
      method: verb,
      headers: {},
    };
    if (data) {
      if (data instanceof FormData){
        options.body = data;
      } 
      else if (typeof data === 'object') {
        options.body = JSON.stringify(data);
        options.headers['Content-Type'] = 'application/json';
      }
    }
    if(this.token)
      options.headers.Authorization = `Token ${this.token}`;


    // Send network request
    return fetch(url, options)
      .catch(Api.networkError)
      .then(Api.checkStatus)
      .then(Api.parseResponse);
  }

  /**
   * Parses the JSON returned by a network request
   *
   * @param  {object} response A response from a network request
   *
   * @return {object}          The parsed JSON from the request
   */
  static parseResponse(response) {
    if (response.status === 204 || response.status === 205) {
      return null;
    }
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return response.json();
    } else {
      return response.text();
    }
  }

  /**
   * Checks if a network request came back fine, and throws an error if not
   *
   * @param  {object} response   A response from a network request
   *
   * @return {object|undefined} Returns either the response, or throws an error
   */
  static checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else if (response.status === 401) {
      // Api.store.dispatch(logout());
    }
    return Api.parseResponse(response).then(responseBody => {
      const error = new Error(response.statusText);
      error.response = responseBody;
      throw error;
    });
  }

  static networkError(error) {
    error.response = {
      network: error.message,
    };
    throw error;
  }
}
